<template>

    <transition-group name="accordion-transition" tag="div" class="accordion transition-wrapper" @after-leave="expandingEnded">
        <collection v-for="collection in visibleCollections"
            :key="collection.id"
            :collection="collection"
            :isExpanded="collection.id === expandedCollection"
            :isLoading="isLoading"
            :isExpanding="isExpanding"
            :isActive="isActive(collection)"
            @expand="expand"
            @collapse="collapse">

            <slot v-bind="collection"></slot>

        </collection>
    </transition-group>

</template>


<script>

import Collection from 'js/admin/components/sidebar/Collection.vue'

export default {
    components: { Collection },
    props: {
        collections: {
            type: Array,
            default: [],
            /*
            [{
                id: 1,
                title: 'Collection title',
            }]
            */
        },
        initialExpanded: {},
        isLoading: {
            type: Boolean,
            default: false,
        },
        hideCollapsed: {
            type: Boolean,
            default: true,
        }
    },

    data: function() {
        return {
            expandedCollection: null,
            isExpanding: false,
        }
    },

    computed: {
        visibleCollections: function() {
            if ( this.expandedCollection != null && this.hideCollapsed ) {
                return this.collections.filter( c => c.id == this.expandedCollection )
            }
            return this.collections
        }
    },

    methods: {
        expand: function(collection) {
            if (collection.link != null) {
                this.$router.push(collection.link)
                if (collection.isExpandable === false) {
                    return
                }
            }
            this.expandedCollection = collection.id
            if ( this.hideCollapsed && this.collections.length > 1 ) {
                this.isExpanding = true
            }
            this.$emit('expanded', collection)
        },
        collapse: function() {
            this.expandedCollection = null
        },

        expandingEnded: function() {
            this.isExpanding = false
        },

        isActive: function(collection) {
            return collection.isExpandable === false && collection.link != null && this.$route.name === collection.link.name
        }
    },

    watch: {
        initialExpanded: {
            handler: function(newVal) {
                this.expandedCollection = newVal
            },
            immediate: true
        }
    }

}
</script>



<style lang="scss">

    @import 'global';

    .accordion {
        padding-top: 1em;
        margin-top: -2px;
    }

</style>



// WEBPACK FOOTER //
// Accordion.vue?0bc5e6eb